/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JobPositionIncludeFilterInner } from './jobPositionIncludeFilterInner';
import { AcademicLevelFilterOrder } from './academicLevelFilterOrder';
import { JobPositionFields } from './jobPositionFields';


export interface JobPositionFilter1 { 
    offset?: number;
    limit?: number;
    skip?: number;
    order?: AcademicLevelFilterOrder;
    where?: { [key: string]: any; };
    fields?: JobPositionFields;
    include?: Array<JobPositionIncludeFilterInner>;
}

